import { Component, input, output } from '@angular/core';
import { IRisk } from '@webapp/risk-core';
import { RiskSkeletonComponent } from '../risk-skeleton/risk-skeleton.component';
import { RiskComponent } from '../risk/risk.component';

@Component({
	selector: 'app-risk-list',
	imports: [RiskComponent, RiskSkeletonComponent],
	templateUrl: './risk-list.component.html',
	styleUrl: './risk-list.component.scss',
})
export class RiskListComponent {
	loading = input(false);
	risks = input<IRisk[]>([]);
	selectEvent = output<IRisk>();

	onSelect(risk: IRisk) {
		this.selectEvent.emit(risk);
	}
}
